module.exports = __webpack_public_path__ + "img/add-member.720e1443.svg";